import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { Button, Field, Input } from "@/lib/ui";
import { useAuth } from "@/context/Auth";

export default function PayoutSetup() {
  const nav = useNavigate();
  const { user, refresh } = useAuth();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [upi, setUpi] = useState(user?.upi_id || "");
  const [busy, setBusy] = useState(false);
  const ref = useRef();
  useEffect(() => {
    if (user?.payout_qr) api.get(`/referor-qr/${user.id}`, { responseType: "blob" }).then(({ data }) => setPreview(URL.createObjectURL(data))).catch(() => {});
  }, [user]);
  const pick = (f) => {
    if (f && f.size > 8 * 1024 * 1024) { toast.error(`Image is ${(f.size / 1048576).toFixed(1)} MB — maximum size is 8 MB`); return; }
    setFile(f); if (f) setPreview(URL.createObjectURL(f));
  };
    const submit = async (e) => {
    e.preventDefault();
    if (!file && !user?.payout_qr) { toast.error("Upload your payment QR code image"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      if (file) fd.append("file", file);
      fd.append("upi_id", upi);
      await api.post("/referor/payout-qr", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(file ? "Payout QR saved — you're all set to receive payouts on the 25th" : "UPI ID updated");
      await refresh(); nav("/referor/app");
    } catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };
  return (
    <div className="mx-auto max-w-xl">
      <h1 className="font-head text-2xl font-extrabold text-slate-900">Set up your payout QR</h1>
      <p className="mt-1 text-sm text-slate-500">You're approved as a Deadstock.live referor. Upload the UPI / bank QR code the admin should scan to pay your commissions on the <b>25th of every month</b>.</p>
      <form onSubmit={submit} className="mt-6 space-y-4 rounded-2xl border border-slate-200 bg-white p-5" data-testid="payout-setup-form">
        <Field label="Payment QR Code Image" required hint="JPG, PNG, WEBP or HEIC · max 8 MB">
          <div onClick={() => ref.current.click()} data-testid="payout-qr-drop" className="flex min-h-[180px] cursor-pointer items-center justify-center rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 p-3 hover:border-orange-400">
            {preview ? <img src={preview} alt="QR" className="max-h-64 rounded-lg" /> : <span className="text-center text-sm text-slate-500"><i className="fa-solid fa-qrcode mb-2 block text-3xl text-orange-500" />Click to upload your UPI / bank QR</span>}
          </div>
          <input ref={ref} type="file" accept="image/*,.heic,.heif" className="hidden" data-testid="payout-qr-file" onChange={(e) => pick(e.target.files?.[0] || null)} />
        </Field>
        <Field label="UPI ID (optional)"><Input data-testid="payout-upi" value={upi} onChange={(e) => setUpi(e.target.value)} placeholder="name@upi" /></Field>
        <Button type="submit" disabled={busy} className="w-full" data-testid="payout-save">{busy ? "Saving…" : user?.payout_qr ? "Update QR" : "Save & Continue"}</Button>
      </form>
    </div>
  );
}
